<template>
    <div class="accordion">
      <slot :toggleItem="toggleItem"></slot>
    </div>
  </template>

  <script>
  export default {
    methods: {
      toggleItem(item) {
        item.isActive = !item.isActive;
      },
    },
  };
  </script>
